import type { TablerIcon } from "@tabler/icons-react";

export const MANTINE_CELL_ICON_SIZE = "1.3rem";

interface MantineCellIconProps {
  IconComponent: TablerIcon;
  iconColor?: string;
  ref?: React.Ref<HTMLSpanElement>;
}

/** An icon component for displaying icons in a Mantine table cell */
function MantineCellIcon({
  IconComponent,
  iconColor,
  ref
}: MantineCellIconProps) {
  return (
    <span ref={ref} style={{ display: "inline-flex" }}>
      <IconComponent
        color={iconColor}
        size={MANTINE_CELL_ICON_SIZE}
        style={{ flexShrink: 0 }}
      />
    </span>
  );
}

export { MantineCellIcon, MantineCellIconProps };
